import React from 'react';
import { t } from '@lingui/macro';

import { Box, Button, Flex, Heading, Image } from '@rover/kibble/core';
import { getSourceDescription } from '@rover/rsdk/src/modules/Network/userAgent';
import fireDataLayerEvent from '@rover/utilities/fireDataLayerEvent';

import { RoverProtectEvents } from '../analytics';
import { getDesktopHeroImg, getMobileHeroImg, widthArray } from '../RoverProtect.utils';

export type Props = {
  personOpk?: string;
  cookieId?: string;
  language?: string;
};

const LandingSection = ({ personOpk, cookieId, language }: Props): JSX.Element => {
  const platform = getSourceDescription();
  const imageSource = platform === 'web' ? getDesktopHeroImg(language) : getMobileHeroImg(language);

  const headingText = t`Over 80 million pet care services have been booked by our community of loving pet people.`;
  const bookNowButtonText = t`Find a local sitter`;

  return (
    <Flex justifyContent="center" mb={['0x', '12x']}>
      <Flex flexDirection="column" width={widthArray}>
        <Box minHeight={['250px', '350px', '450px', '610px']}>
          <Image
            src={imageSource}
            description="Rover Protect Landing Image"
            width="100%"
            height="auto"
            mb={['0x', '6x']}
          />
        </Box>
        <Box
          display="flex"
          flexDirection={['column', 'row']}
          justifyContent="space-between"
          alignItems="center"
          background="secondary"
          borderRadius="primary"
          mx={['4x', '0x']}
          py="4x"
          px="6x"
          mt={['6x', '0x']}
          mb="4x"
          sx={{ gap: '6x' }}
        >
          <Heading size="300" mb="0x">
            {headingText}
          </Heading>
          <Button
            variant="primary"
            href="/search"
            m={['2x', '0x']}
            width={['100%', 'auto']}
            onPress={() => {
              fireDataLayerEvent(
                RoverProtectEvents.SearchClick({ source: platform, personId: personOpk, cookieId })
              );
            }}
          >
            {bookNowButtonText}
          </Button>
        </Box>
      </Flex>
    </Flex>
  );
};

export default LandingSection;
